import { isArray } from "lodash";

import { EntityTypes } from "../../EntityTypes";
import { IUserResource } from "../../users";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { IBriefResource } from "../types/IBriefResource";

export type IBriefCoeditionAssignMutationParameters = {
    brief: RelationalValue<IBriefResource>;
    coeditors: RelationalValue<IUserResource>[];
};

export type IBriefCoeditionAssignMutationResult = IBriefResource;

export const briefAddCoeditorsMutation: IApiMutationFunction<IBriefCoeditionAssignMutationParameters> = ({
    brief,
    coeditors,
}) => {
    return {
        method: "PATCH",
        url: `/briefs/${mapRelationalValue(brief)}/coedition`,
        headers: {
            "Content-Type": "application/merge-patch+json",
        },
        data: {
            coeditors: (isArray(coeditors) ? coeditors : [coeditors]).map(coeditor =>
                mapRelationalValueAsIRI(EntityTypes.USER, coeditor),
            ),
        },
    };
};

export const useBriefAddCoeditorsMutation = createApiMutationHook<
    IBriefCoeditionAssignMutationParameters,
    IBriefCoeditionAssignMutationResult
>(briefAddCoeditorsMutation);
